




































import { Component, Vue } from 'vue-property-decorator';
import { ALL_PAYMENT_METHODS } from '@/queries/PaymentMethod';
import PaymentMethodEditButton from '@/components/PaymentMethod/PaymentMethodEditButton.vue';
import PaymentMethodNewButton from '@/components/PaymentMethod/PaymentMethodNewButton.vue';
import PaymentMethodShowButton from '@/components/PaymentMethod/PaymentMethodShowButton.vue';
import PaymentMethodDeleteButton from '@/components/PaymentMethod/PaymentMethodDeleteButton.vue';
import PermissionService from '@/utils/permission-service';

@Component({
  components: {
    PaymentMethodEditButton,
    PaymentMethodNewButton,
    PaymentMethodShowButton,
    PaymentMethodDeleteButton,
  },
})
export default class PaymentMethodList extends Vue {
  private ALL_PAYMENT_METHODS = ALL_PAYMENT_METHODS;
  private PermissionService = PermissionService;
}
